import React, { useContext, useEffect, useState } from 'react'
import { Container, Grid, IconButton, Paper, Typography, Button } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { useNavigate } from 'react-router-dom'
import { ContextoGlobal, ContextoGlobalInterface } from '../../GlobalStates/ContextoGlobal'
import BackEndAPI from '../../Services/BackEndAPI'
import InputText from '../../DevComponents/InputText'
import SelectMultiplo from '../../DevComponents/SelectMultiplo'
import ClsFormatacao from '../../Utils/ClsFormatacao'
import { MensagemTipo } from '../../GlobalStates/MensagemState'
import { RespostaPadraoInterface } from '../../ImportBackend/Interfaces/PadraoInterfaces'
import { TipoMapaProducaoInterface } from '../../ImportBackend/Interfaces/TipoMapaProducaoInterfaces'

interface PesquisaLeituraManualInterface {
  dataProducao: string
  tiposMapaProducao: Array<TipoMapaProducaoInterface>
}

export default function RelLeituraManual() {

  const navigate = useNavigate()
  const contexto = useContext(ContextoGlobal) as ContextoGlobalInterface
  const clsApi = new BackEndAPI()
  const clsFormatos = new ClsFormatacao()

  const [pesquisa, setPesquisa] = useState<PesquisaLeituraManualInterface>({
    dataProducao: clsFormatos.dateParaDateSQL(new Date()),
    tiposMapaProducao: []
  })

  const btFechar = () => {
    navigate('/')
  }

  const btGerarLeituraManual = () => {

    if (!pesquisa.dataProducao) {
      contexto.setMensagemState({
        cb: null,
        exibir: true,
        exibirBotao: true,
        mensagem: 'Informe a data de produção.',
        titulo: 'Atenção!',
        tipo: MensagemTipo.Warning
      })
      return
    }

    const idsTipoMapaProducao = pesquisa.tiposMapaProducao.map(e => e.idTipoMapaProducao)

    const query = `
      getPDFLeituraManual(
        dataProducao: "${pesquisa.dataProducao}",
        idsTipoMapaProducao: [${idsTipoMapaProducao.join(', ')}]
      ) {
        ok
        mensagem
      }
    `

    clsApi.query<RespostaPadraoInterface>(
      query,
      'getPDFLeituraManual',
      'Gerando Leitura Manual...',
      contexto
    ).then(rs => {

      if (rs.ok) {

        const linkSource = `data:application/pdf;base64,${rs.mensagem}`
        const downloadLink = document.createElement('a')
        document.body.appendChild(downloadLink)
        downloadLink.href = linkSource
        downloadLink.target = '_self'
        downloadLink.download = `LeituraManual_${pesquisa.dataProducao}.pdf`
        downloadLink.click()
        document.body.removeChild(downloadLink)

      } else {

        contexto.setMensagemState({
          cb: null,
          exibir: true,
          exibirBotao: true,
          mensagem: rs.mensagem,
          titulo: 'Erro ao Gerar!',
          tipo: MensagemTipo.Error
        })

      }

    }).catch(() => {
      contexto.setMensagemState({
        cb: null,
        exibir: true,
        exibirBotao: true,
        mensagem: 'Erro ao gerar relatório de leitura manual.',
        titulo: 'Erro!',
        tipo: MensagemTipo.Error
      })
    })
  }

  return (
    <Container maxWidth="md" sx={{ mt: 5 }}>
      <Paper variant="outlined" sx={{ padding: 2 }}>

        <Grid container sx={{ display: 'flex', alignItems: 'stretch' }}>

          <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'space-between', mb: 3 }}>
            <Typography component="h5" variant="h5" align="left">
              Leitura Manual
            </Typography>
            <IconButton onClick={btFechar}>
              <CloseIcon />
            </IconButton>
          </Grid>

          <Grid item xs={12} md={4}>
            <InputText
              dados={pesquisa}
              field='dataProducao'
              label='Data de Produção'
              setState={setPesquisa}
              type='date'
            />
          </Grid>

          <Grid item xs={12} md={8} sx={{ pl: { md: 1 } }}>
            <SelectMultiplo
              label='Tipos de Mapa de Produção (vazio = todos)'
              dados={pesquisa}
              field='tiposMapaProducao'
              fieldIdSelect='idTipoMapaProducao'
              fieldSelect='descricao'
              fieldsRetornoObjeto={['idTipoMapaProducao']}
              setState={setPesquisa}
              pesquisaInicial={{
                mensagem: 'Pesquisando Tipos de Mapa de Produção',
                tipo: 'Query',
                pesquisa: `getTiposMapaProducao {idTipoMapaProducao descricao}`,
                objRetorno: 'getTiposMapaProducao'
              }
              }
            />
          </Grid>

          {/*
                        <Grid item xs={12}>
          
                          <SelectMultiplo
                            dados={dados}
                            fieldsRetornoObjeto={['idMaterial']}
                            disabled={statusForm === StatusForm.Excluindo}
                            field='Materiais'
                            fieldIdSelect='idMaterial'
                            fieldSelect='descricao'
                            label='Materiais'
                            setState={setDados}
                            erros={erros}
                            pesquisaInicial={{
                              mensagem: 'Pesquisando Materiais',
                              tipo: 'Query',
                              pesquisa: `getMateriais {idMaterial descricao}`,
                              objRetorno: 'getMateriais'
                            }
                            }
                          />
          
                        </Grid>
                              */}

          <Grid item xs={12} sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end' }}>
            <Button
              variant='contained'
              onClick={btGerarLeituraManual}
            >
              Download
            </Button>
          </Grid>

        </Grid>

      </Paper>
    </Container>
  )
}
